import * as React from "react";
const SvgHexagon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 69, height: 80, viewBox: "0 0 69 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M34.237 0L68.0162 20V60L34.237 80L0.457792 60V20L34.237 0Z", fill: "#2C3F57" }));
export default SvgHexagon;
